import { MasterDataTable } from "@/components/MasterDataTable";
import { useAdminTherapyAreas, useTherapyAreaAdmin } from "@/hooks/useMasterData";

const TherapyAreas = () => {
  const { data: therapyAreas = [], isLoading } = useAdminTherapyAreas();
  const admin = useTherapyAreaAdmin();

  return (
    <MasterDataTable
      items={therapyAreas.map((i) => ({ id: i.id, label: i.name, is_active: i.is_active }))}
      valueLabel="Name"
      isLoading={isLoading}
      onCreate={(name) => admin.create.mutateAsync(name)}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default TherapyAreas;
